import React, { Component, PropTypes } from 'react';
import * as B from 'react-bootstrap';
import ChatHeader from './ChatHeader';
import ChatTextWraper from './ChatTextWraper';
import ChatWebRTC from 'containers/chat/webrtc';
import chatConfiguration from 'config';
import { WEB_RTC_FEATURES } from 'actions/chat/webrtc';
import Modable from 'components/lib/Modable';
import { CHAT_MODAL } from 'actions/chat';
import ChooseCamera from 'containers/chat/webrtc/chooseCamera';
import FileUpload from 'containers/chat/fileUpload/';
import Lightbox from 'react-image-lightbox'
import Immutable from 'immutable';

const configuration = chatConfiguration.chat;
const modals = new Map([
  [CHAT_MODAL.chooseCamera, props => <ChooseCamera modalProps={props} />],
  [CHAT_MODAL.fileUpload, props => <FileUpload modalProps={props} />]
]);

const queuePropertiesPropTypes = PropTypes.shape({
  showSendTranscript: PropTypes.bool.isRequired,
  sendEmailButtonLabel: PropTypes.string.isRequired,
  agentIsTypingMessage: PropTypes.string.isRequired,
  sendButtonLabel: PropTypes.string.isRequired,
  endButtonLabel: PropTypes.string.isRequired,
  useTPClientSurvey: PropTypes.bool.isRequired,
});

@Modable(modals)
class Chat extends Component {
  static propTypes = {
    ...ChatTextWraper.propTypes,
    ...ChatHeader.propTypes,
    queueProperties: queuePropertiesPropTypes,
    appWidth: PropTypes.number,
    webRTCStarted: PropTypes.bool,
    webRTCMode: PropTypes.string,
    interactiveSurveyEnabled: PropTypes.bool.isRequired,
    interactiveSurveyRetrieved: PropTypes.bool.isRequired,
    surveyCode: PropTypes.string,
    modal: PropTypes.number,
    videoFullscreen: PropTypes.bool,
    onGetInteractiveSurveyInformation: PropTypes.func,
    chosenCamera: PropTypes.string,
    fileUploadProgress: PropTypes.arrayOf(PropTypes.any),
    receivedImageBeingShown: PropTypes.object,
    hideSendButton: PropTypes.bool,
    onEndWebRTC: PropTypes.func.isRequired,
    onCancelImageView: PropTypes.func.isRequired,
  };
  static VIDEO_DISPLAY_MODE = {
    wide: 'video/mode/wide',
    fullscreen: 'video/mode/fullscreen',
  }
  static VIDEO_WIDE_BREAKPOINT = 1000;
  static HEADER_HEIGHT = 42;
  static AUDIO_HEIGHT = 60;
  componentDidMount() {
    if (this.props.interactiveSurveyEnabled && !this.props.queueProperties.useTPClientSurvey && this.props.surveyCode && !this.props.interactiveSurveyRetrieved) {
      this.props.onGetInteractiveSurveyInformation();
    }
  }
  get headerProps() {
    let headerKeys = Object.keys(ChatHeader.propTypes);
    return Immutable.Map(this.props).filter((p, k) => headerKeys.includes(k)).toObject();
  }
  get textProps() {
    let textKeys = Object.keys(ChatTextWraper.propTypes);
    return Immutable.Map(this.props).filter((p, k) => textKeys.includes(k)).toObject();
  }
  get videoDisplayMode() {
    return this.props.videoFullscreen ? Chat.VIDEO_DISPLAY_MODE.fullscreen : (
      this.props.appWidth > Chat.VIDEO_WIDE_BREAKPOINT
        ? Chat.VIDEO_DISPLAY_MODE.wide : Chat.VIDEO_DISPLAY_MODE.fullscreen
    );
  }
  get webRTCVideo () {
    return [WEB_RTC_FEATURES.oneWayVideo, WEB_RTC_FEATURES.twoWayVideo].includes(this.props.webRTCMode);
  }
  get webRTCAudio () {
    return this.props.webRTCStarted && this.props.webRTCMode === WEB_RTC_FEATURES.audioOnly;
  }
  get textWraperHeight () {
    return this.props.appHeight
      - (!this.props.ended ? Chat.HEADER_HEIGHT : 0)
      - (this.webRTCAudio ? Chat.AUDIO_HEIGHT : 0);
  }
  ownVideoScreenSnapshot() {
    const wrappedInstance = this.webRtc && this.webRtc.getWrappedInstance();
    return wrappedInstance && wrappedInstance.ownScreenSnapshot();
  }
  switchOwnCamera() {
    const wrappedInstance = this.webRtc && this.webRtc.getWrappedInstance();
    if (wrappedInstance) {
      wrappedInstance.switchCamera();
      return true;
    }
  }
  sendFiles(files) {
    files.forEach(f => {
      if (f.fileType === 'image') {
        this.props.onSendMessage(`[tpclient_external_image:${f.guid}]`);
      } else if (f.fileType === 'file') {
        this.props.onSendMessage(`[tpclient_external_file:${f.file}]`);
      } else {
        console.error(`File type ${f.fileType} is not supported yet`);
      }
    });
  }
  componentWillReceiveProps(nextProps) {
    if (!nextProps.ended && !nextProps.webRTCStarted && (nextProps.startVideoImmediately || nextProps.chosenCamera)) {
      this.props.onStartWebRTC(this.props.onStartWebRTCInternal, this.props.connectionId, this.props.preferedVideoMode);
    }
  }
  render() {
    let wide = this.videoDisplayMode === Chat.VIDEO_DISPLAY_MODE.wide;

    return (
      <div className="chat-wraper">
        {
          this.modal({
            onSendFilesToAgents: this.sendFiles.bind(this),
            container: this,
          })
        }
        {
          this.props.receivedImageBeingShown ? (
            <Lightbox
              mainSrc={typeof this.props.receivedImageBeingShown === 'object'
                ? this.props.receivedImageBeingShown.url
                : this.props.receivedImageBeingShown}
              onCloseRequest={this.props.onCancelImageView}
              imageCaption={typeof this.props.receivedImageBeingShown === 'object'
                ? this.props.receivedImageBeingShown.comments
                : undefined}
            />
          ) : undefined
        }
        <B.Grid fluid>
          <B.Row className="show-grid">
            {
              this.webRTCVideo ? (
                <B.Col xs={wide ? 7 : 12}>
                  <ChatWebRTC ref={c => this.webRtc = c} onEndWebRTC={this.props.onEndWebRTC} height={this.props.appHeight} />
                </B.Col>
              ) : undefined
            }
            {
              this.webRTCAudio || !this.props.webRTCStarted || wide ? (
                <B.Col xs={!this.webRTCAudio && this.props.webRTCStarted ? 5 : 12}>
                  {
                    !this.props.ended && (this.webRTCAudio || !this.props.webRTCStarted)
                      ? (
                        <ChatHeader {...this.headerProps}
                          height={Chat.HEADER_HEIGHT}
                          webRTCStarted={this.props.webRTCStarted}
                        />
                      ) : undefined
                  }
                  {
                    !this.props.ended && this.props.fileUploadProgress ? (
                      <B.Well bsSize="small" className="chat-file-upload-well"
                        onClick={this.props.onStartFileUpload}
                      >
                        Subiendo archivos
                      </B.Well>
                    ) : undefined
                  }
                  {
                    this.webRTCAudio ? (
                      <ChatWebRTC ref={c => this.webRtc = c} onEndWebRTC={this.props.onEndWebRTC} height={Chat.AUDIO_HEIGHT} />
                    ) : undefined
                  }
                  <ChatTextWraper { ...this.textProps }
                    shrunk={!this.webRTCAudio && this.props.webRTCStarted}
                    height={this.textWraperHeight}
                  />
                </B.Col>
              ) : undefined
            }

          </B.Row>
        </B.Grid>
      </div>
    );
  }
}

export default Chat;



// WEBPACK FOOTER //
// ./components/chat/Chat.js